import React, {useState} from 'react'
import Canvas from "../canvas/Canvas"

import thumb14 from '../images/thumb_14.jpg';
import thumb15 from '../images/thumb_15.jpg';
import thumb16 from '../images/thumb_16.jpg';

import img14 from '../images/14.png';
import img15 from '../images/15.png';
import img16 from '../images/16.png';

import { Modal } from 'react-bootstrap';
import "./modal.css";

export default function Cornea(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Lids");
    const [showImage,setShowImage] = useState(img14);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }
    return(
        <>
           <div className="card card-custom gutter-b">
                <div className="card-header">
                    <div className="card-title">
                        <h3 className="card-lable">
                            Cornea/Sclera
                        </h3>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">

                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb14}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Episcleritis</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Cornea/Sclera - Episcleritis",img14)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb15}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Neovascularization</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Cornea/Sclera - Neovascularization",img15)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb16}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Scleritis</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Cornea/Sclera - Scleritis",img16)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 



                    </div>
                </div>
            </div>      
            <Modal
                show={show}
                size="lg"
                onHide={()=>setShow(false)}
                dialogClassName="modal-90w"
                >
                    <Modal.Header closeButton>
                      
                        <Modal.Title>
                            Eye Draw - {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>     
                      {/*   <Image src={img1} fluid />*/}
                      <div style={{height:"70vh",width:"60vw"}}>
                      <Canvas image={showImage} />
                      </div>
                     
                    </Modal.Body>
                </Modal>       
        </>
    )
}